module.exports = __webpack_public_path__ + "../static/img/logo-dark.d282e9f6.png";